import { RootDispatch } from "../types";

export const SET_MESSAGE_SCROLLTOP = "messaging/setScrollTop";

interface SetMessageSrollTop {
  type: typeof SET_MESSAGE_SCROLLTOP;
  scrollTop: number;
}

export type Action = SetMessageSrollTop;

export const setMobileMessagingScrollTop = (scrollTop: number) => async (
  dispatch: RootDispatch
) => {
  dispatch({ type: "messaging/setScrollTop", scrollTop: scrollTop });
};
